import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { buildBreadcrumbListJsonLd } from '@/lib/breadcrumbs/build-breadcrumbs';
import { BreadcrumbItem } from '@/lib/breadcrumbs/types';
interface Props {
  items: BreadcrumbItem[];
}
const BreadcrumbListJsonLd: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  if (items.length <= 1) {
    return null;
  }
  let t1;
  if ($[0] !== items) {
    t1 = JSON.stringify(buildBreadcrumbListJsonLd(items));
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default BreadcrumbListJsonLd;